var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: _vm.load,
      expression: "load"
    }],
    attrs: {
      "infinite-scroll-disabled": "disabled",
      "infinite-scroll-distance": "128"
    }
  }, [_c('p', {
    staticClass: "display px-4 primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Weapons')) + " (" + _vm._s(_vm.weaponList.length) + ")")]), _c('div', {
    staticClass: "px-4 mb-2"
  }, [Object.values(_vm.query).flat().length ? _c('v-chip', {
    staticClass: "float-right",
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          query: {}
        });
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-delete")])], 1) : _vm._e(), Object.values(_vm.query).flat().length == 0 ? _c('v-chip', {
    key: "weapons-query-empty",
    staticClass: "mb-2 mr-2"
  }, [_vm._v(_vm._s(_vm.$t('All')))]) : _vm._e(), _vm._l(_vm.query, function (values, key) {
    return [_vm._l(values, function (value) {
      return [_c('v-chip', {
        key: "weapons-query-".concat(key, "-").concat(value),
        staticClass: "mb-2 mr-2",
        on: {
          "click": function click($event) {
            _vm.input = "".concat(key, " = ").concat(value);
          }
        }
      }, [_c('span', {
        staticClass: "pr-1 d-block",
        staticStyle: {
          "max-width": "256px",
          "overflow": "hidden"
        }
      }, [_vm.$s.advancedFilter ? [_c('span', {
        staticClass: "primary--text",
        staticStyle: {
          "font-weight": "550"
        }
      }, [_vm._v(_vm._s(key) + " =")]), _c('span', [_vm._v(_vm._s(value))])] : key == 'rare' ? [_c('span', [_vm._v(_vm._s(_vm.$t("Rares.".concat(value))))])] : key == 'class' ? [_c('span', [_vm._v(_vm._s(_vm.$t("Classes.".concat(value))))])] : key == 'element' ? [_c('span', [_vm._v(_vm._s(_vm.$t("Elements.".concat(value))))])] : key == 'title' ? [_c('span', [_vm._v(_vm._s(_vm.$name(_vm.$store.state.$db.TitleList[value].m_DisplayName)))])] : key == 'skill' ? [_c('span', {
        staticClass: "primary--text",
        staticStyle: {
          "font-weight": "550"
        }
      }, [_vm._v("skill")])] : key == 'passive' ? [_c('span', {
        staticClass: "primary--text",
        staticStyle: {
          "font-weight": "550"
        }
      }, [_vm._v("passive: " + _vm._s(_vm.$t('Passive Types.' + String(JSON.parse(value).type))))])] : key == 'name' ? [_c('span', [_vm._v(_vm._s(value))])] : [_c('span', {
        staticClass: "primary--text",
        staticStyle: {
          "font-weight": "550"
        }
      }, [_vm._v(_vm._s(key) + " =")]), _c('span', [_vm._v(_vm._s(value))])]], 2), _c('v-icon', {
        attrs: {
          "small": ""
        },
        on: {
          "click": function click($event) {
            return _vm.q(key, value);
          }
        }
      }, [_vm._v("mdi-close")])], 1)];
    })];
  })], 2), _c('v-divider'), _c('v-row', {
    staticClass: "my-2",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Rare')))])], 1), _c('v-list-item-action', {
    staticClass: "ma-0 d-flex flex-row align-center"
  }, _vm._l(_vm.rares, function (rare) {
    return _c('v-chip', {
      key: "weapons-filters-rare-".concat(rare),
      staticClass: "ml-1",
      on: {
        "click": function click($event) {
          return _vm.q('rare', rare);
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("Rares.".concat(rare))))]);
  }), 1)], 1), _c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Class')))])], 1), _c('v-list-item-action', {
    staticClass: "ma-0 d-flex flex-row align-center"
  }, _vm._l(_vm.classes, function (icon, i) {
    return _c('v-avatar', {
      key: "weapons-filters-class-".concat(i),
      staticClass: "ml-1",
      attrs: {
        "size": "32"
      }
    }, [_c('v-img', {
      attrs: {
        "src": _vm.$asset.commonuiatlas.format(icon) + '.png'
      },
      on: {
        "click": function click($event) {
          return _vm.q('class', i);
        }
      }
    })], 1);
  }), 1)], 1), _c('v-list-item', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Evolution')))])], 1), _c('v-list-item-action', {
    staticClass: "ma-0 d-flex flex-row align-center"
  }, [_c('v-chip', {
    staticClass: "ml-1",
    on: {
      "click": function click($event) {
        return _vm.q('evolution', 0);
      }
    }
  }, [_vm._v("0")]), _c('v-chip', {
    staticClass: "ml-1",
    on: {
      "click": function click($event) {
        return _vm.q('evolution', 3);
      }
    }
  }, [_vm._v("3")]), _c('v-chip', {
    staticClass: "ml-1",
    on: {
      "click": function click($event) {
        return _vm.q('evolution', 4);
      }
    }
  }, [_vm._v("4")])], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-menu', {
    attrs: {
      "offset-x": "",
      "max-width": "256"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-list-item', _vm._g({
          attrs: {
            "dense": ""
          }
        }, on), [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Title')))])], 1), _c('v-list-item-action', {
          staticClass: "ma-0"
        }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)];
      }
    }])
  }, [_c('v-list', {
    staticClass: "overflow-y-auto",
    attrs: {
      "dense": "",
      "max-height": "calc(100vh - 24px)"
    }
  }, _vm._l(_vm.$store.state.$db.TitleListArray, function (title) {
    return _c('v-list-item', {
      key: "weapons-filter-title-".concat(title.m_TitleType),
      on: {
        "click": function click($event) {
          return _vm.q('title', title.m_TitleType);
        }
      }
    }, [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$name(title.m_DisplayName)))])], 1)], 1);
  }), 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "512"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('v-list-item', _vm._g({
          attrs: {
            "dense": ""
          }
        }, on), [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Skill')))])], 1), _c('v-list-item-action', {
          staticClass: "ma-0"
        }, [_c('v-icon', [_vm._v("mdi-dots-horizontal")])], 1)], 1)];
      }
    }])
  }, [_c('SkillSelector', {
    attrs: {
      "push": function push(x) {
        return _vm.q('skill', x);
      }
    }
  })], 1), _c('v-dialog', {
    attrs: {
      "max-width": "512"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref3) {
        var on = _ref3.on;
        return [_c('v-list-item', _vm._g({
          attrs: {
            "dense": ""
          }
        }, on), [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t('Passive Skill')))])], 1), _c('v-list-item-action', {
          staticClass: "ma-0"
        }, [_c('v-icon', [_vm._v("mdi-dots-horizontal")])], 1)], 1)];
      }
    }])
  }, [_c('PassiveSelector', {
    attrs: {
      "push": function push(x) {
        return _vm.q('passive', x);
      }
    }
  })], 1)], 1)], 1), _c('v-text-field', {
    staticClass: "px-4",
    attrs: {
      "dense": "",
      "placeholder": _vm.$t('Input.Filter')
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.input,
      callback: function callback($$v) {
        _vm.input = $$v;
      },
      expression: "input"
    }
  }), _vm._l(_vm.weaponList.slice(0, _vm.show), function (weapon, i) {
    return [_vm.$ad(i) ? [_c('v-divider'), _c('Ad', {
      key: "weapons-ad-".concat(i)
    })] : _vm._e(), _c('v-divider'), _c('Weapon', {
      key: "weapons-weapon-".concat(weapon.m_ID),
      attrs: {
        "id": weapon.m_ID
      }
    })];
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }